import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { columns } from "./columns.js";
import CardTable from "components/CardTable/CardTable.jsx";
import RegularButton from "components/CustomButtons/Button.js";
import { useToggle } from "hooks/useToggle.js";
import { ModalV2 } from "components/Modal/ModalV2.jsx";
import { PrinterForm } from "./PrinterForm";
import Snackbar from "components/Snackbar/Snackbar.js";
import { useSearch } from "hooks/useSearch.js";
import { printersSelector } from "./selectors.js";
import { useHandleStation } from "./actions.js";
import { getPrinters } from "redux/actions/printers/printersActions.js";
import PrintIcon from "@material-ui/icons/Print";
import { Autocomplete } from "@material-ui/lab";
import { Grid, TextField } from "@material-ui/core";

export const PrintersView = () => {
  const [open, setOpen] = useToggle();
  const dispatch = useDispatch();
  const printers = useSelector(printersSelector);
  const { stationsList } = useSelector(({ companies }) => companies);
  const { isOpen, color, message, isLoadingComp, configTables } = useSelector(
    ({ search }) => search
  );
  const { clearSnackbar } = useSearch();
  const { filterData, handleStation } = useHandleStation(printers);
  const { buildCompLoadings, buildTableConfig } = useSearch();

  useEffect(() => {
    printers.length === 0 && dispatch(getPrinters());
    isLoadingComp.loadingNewPrinter === null &&
      buildCompLoadings(["loadingFormPrinter"]);
    !configTables?.printersTableConfig &&
      buildTableConfig("printersTableConfig");
  }, []);

  return (
    <>
      <CardTable
        columns={columns}
        data={filterData}
        hasControl
        hasHeader
        icon={<PrintIcon />}
        title="Impresoras registradas"
        titleBlock
        blockBtn
        tableKey="printersTableConfig"
        tableContent={
          <Grid container spacing={2} style={{ display: "flex", alignItems: "center" }}>
            <Grid item xs={12} sm={3} md={3}>
              <Autocomplete
                id="printer-autoselect"
                options={stationsList}
                getOptionLabel={(option) =>
                  option.label ? option.label : option.name || ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Estación"
                    variant="outlined"
                    size="small"
                  />
                )}
                fullWidth
                onChange={(e, v) => handleStation(e, v)}
                noOptionsText="No se encuentra la planta"
              />
            </Grid>
          </Grid>
        }
        controls={
          <RegularButton
            round
            justIcon
            color="info"
            onClick={setOpen}
            tooltip="Agregar nueva impresora"
            size="sm"
          >
            +
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        onClose={setOpen}
        title="Agregar nueva impresora"
        // toRight
      >
        <PrinterForm />
      </ModalV2>
      <Snackbar
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
